import { listVideoRequests } from "./../api/VideoRequest/listVideoRequests";
import { LoadingStore } from "./loadingStore";
import { action, observable, reaction } from "mobx";
import notificationStore from "./notificationStore";
import { VideoRequestSummaryModel } from "@/api/VideoRequest";

export type TableOptions = {
  page: number;
  itemsPerPage: number;
  sortBy: string[];
  sortDesc: boolean[];
  groupBy: string[];
  groupDesc: boolean[];
  multiSort: boolean;
  mustSort: boolean;
};

export class VideoRequestStore {
  @observable loading = new LoadingStore();
  @observable videoRequests: VideoRequestSummaryModel[] = [];
  @observable totalPages = 1;
  @observable totalRecords = 0;
  @observable requestsRemaining: number | undefined;
  @observable options: TableOptions = {
    page: 1,
    itemsPerPage: 10,
    sortBy: ["requestedAt"],
    sortDesc: [true],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true
  };

  private fetchDebounceTimeout: ReturnType<typeof setTimeout> | null = null;
  constructor() {
    reaction(
      () => [this.options.page, this.options.itemsPerPage, this.options.sortBy.slice(), this.options.sortDesc.slice()],
      () => {
        if (this.fetchDebounceTimeout) {
          clearTimeout(this.fetchDebounceTimeout);
        }
        this.fetchDebounceTimeout = setTimeout(() => {
          this.fetchVideoRequests();
        }, 50); // 50ms debounce
      }
    );
  }

  @action.bound async fetchVideoRequests() {
    const request = {
      page: this.options.page - 1,
      pageSize: this.options.itemsPerPage,
      sortBy: this.options.sortBy.length ? this.options.sortBy[0] : "requestedAt",
      sortDesc: this.options.sortDesc.length ? this.options.sortDesc[0] : true
    };

    return this.loading.track(async () => {
      try {
        const response = await listVideoRequests(request);
        this.videoRequests = response.videoRequests;
        this.totalPages = response.totalPages;
        this.totalRecords = response.totalRecords;
        this.requestsRemaining = response.requestsRemaining;
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading the video requests");
      }
    }, "fetchVideoRequests");
  }

  @action.bound resetResults() {
    this.videoRequests = [];
    this.options.page = 1;
  }
}

const videoRequestStore = new VideoRequestStore();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).videoRequestStore = videoRequestStore;

export default videoRequestStore;
